import React, { useEffect, useState, useRef } from 'react';
function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
export function SolutionSection() {
  const {
    ref,
    inView
  } = useInView();
  const qualities = [{
    icon: '🎯',
    title: 'Criterio',
    desc: 'Buscan a alguien que sepa gestionar con madurez y responsabilidad real'
  }, {
    icon: '⏰',
    title: 'Puntualidad',
    desc: 'Que sea puntual, fiable y cumpla lo que promete sin excusas'
  }, {
    icon: '🧠',
    title: 'Madurez',
    desc: 'Que tenga criterio, experiencia real y sepa resolver problemas'
  }];
  return <section className="section-cream py-20 lg:py-28" ref={ref} data-id="element-176">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-177">
        {/* Header */}
        <div className="text-center mb-12 transition-all duration-700" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)'
      }} data-id="element-178">
          <p className="font-body font-bold tracking-widest text-sm uppercase mb-3" style={{
          color: '#C9A84C'
        }} data-id="element-179">
            La oportunidad real
          </p>
          <h2 className="font-heading font-black mb-4" style={{
          color: '#1B3A5C',
          fontSize: 'clamp(1.8rem, 4vw, 3rem)'
        }} data-id="element-180">
            Mientras Tanto, Hay Una Nueva Economía
          </h2>
          <p className="font-body text-lg max-w-2xl mx-auto" style={{
          color: '#3A4A5A'
        }} data-id="element-181">
            Miles de dueños de negocios digitales están{' '}
            <strong style={{
            color: '#1B3A5C'
          }} data-id="element-182">
              ahogados en el caos
            </strong>
            . Tienen herramientas, tienen seguidores, pero no saben organizar
            una factura, no saben tratar a un cliente difícil y no tienen ni
            idea de lo que es la responsabilidad real.
          </p>
        </div>

        {/* Big callout */}
        <div className="p-8 lg:p-12 rounded-2xl text-center mb-16 transition-all duration-700 delay-200" style={{
        background: 'linear-gradient(135deg, #1B3A5C 0%, #0F2540 100%)',
        border: '2px solid #C9A84C',
        opacity: inView ? 1 : 0,
        transform: inView ? 'scale(1)' : 'scale(0.97)'
      }} data-id="element-183">
          <p className="font-heading font-black leading-tight mb-4" style={{
          color: '#FAF7F2',
          fontSize: 'clamp(1.4rem, 3vw, 2.2rem)'
        }} data-id="element-184">
            Ellos no buscan una{' '}
            <span style={{
            color: '#C9A84C'
          }} data-id="element-185">
              "niña de 20 años"
            </span>
            <br data-id="element-186" />
            que se distrae con TikTok.
          </p>
          <p className="font-heading font-black text-2xl lg:text-3xl" style={{
          color: '#C9A84C'
        }} data-id="element-187">
            TE BUSCAN A TI.
          </p>
          <p className="font-body text-base mt-4" style={{
          color: '#C8D8E8'
        }} data-id="element-188">
            Buscan a alguien que sepa gestionar, que sea puntual, que tenga
            criterio.
          </p>
        </div>

        {/* Three qualities */}
        <div className="grid md:grid-cols-3 gap-6" data-id="element-189">
          {qualities.map((q, i) => <div key={q.title} className="text-center p-6 rounded-2xl transition-all duration-700" style={{
          backgroundColor: '#FAF7F2',
          border: '1px solid #E0D8C8',
          boxShadow: '0 4px 20px rgba(27,58,92,0.08)',
          opacity: inView ? 1 : 0,
          transform: inView ? 'translateY(0)' : 'translateY(30px)',
          transitionDelay: `${400 + i * 150}ms`
        }} data-id="element-190">
              <div className="text-4xl mb-4" data-id="element-191">{q.icon}</div>
              <h3 className="font-heading font-bold text-xl mb-2" style={{
            color: '#1B3A5C'
          }} data-id="element-192">
                {q.title}
              </h3>
              <p className="font-body text-sm leading-relaxed" style={{
            color: '#5A6A7A'
          }} data-id="element-193">
                {q.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}